//Http Headers
export const HTTP_HEADER_ACCEPT_LANGUAGE = 'accept-language';
export const HTTP_HEADER_SELECTED_LANGUAGE = 'ps-language';
